import {
  EVideoSource,
  EVideoUploadStatus,
  TVideNode,
} from '@/pages/backend/cardCampSettings/nodeSettings/videoCom/videoNode';
import React, { FC, useEffect, useRef, useState } from 'react';
import styles from '../index.less';
import {
  CloseCircleOutlined,
  DeleteOutlined,
  ImportOutlined,
  MenuOutlined,
  PlusSquareOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, MenuProps, Popconfirm, Space, Spin } from 'antd';
import DragList from '@/pages/backend/cardCampSettings/nodeSettings/DragList';
import { formatVideoDuration } from '@/utils/index';
import { isUndefined } from 'lodash';
import VideoModal from '@/pages/backend/cardCampSettings/nodeSettings/videoCom/videoModal';
import NameEdit from '@/pages/backend/cardCampSettings/recruitPageSettings/NameEdit';
import VideoUpload from '@/pages/backend/cardCampSettings/nodeSettings/videoCom/videoUpload';
import VideoDuration from '@/pages/backend/cardCampSettings/nodeSettings/videoCom/videoDuration';
import SetDuration from '@/pages/backend/cardCampSettings/nodeSettings/videoCom/setDuration';
import { useUpdateEffect } from 'ahooks';

type TVideoComProps = {
  onChange: (videos: TVideNode[]) => void;
  toggleIsFullScreen: (isFullScreen: boolean) => void;
  defaultValue?: TVideNode[];
};

const VideoCom: FC<TVideoComProps> = (props) => {
  const uploadCache = useRef<TVideNode[]>([]);
  const uploadCancelCache = useRef<string[]>([]);
  const videoUploadRef = useRef<any>(null);
  const { onChange, defaultValue, toggleIsFullScreen } = props;
  const [visible, setVisible] = useState(false);
  const [videoList, setVideoList] = useState<TVideNode[]>(defaultValue || []);
  const normalizeVideoList = (list: TVideNode[]) =>
    list.map((item, index) => ({
      ...item,
      index,
    }));
  const upsertVideo = (file: Omit<TVideNode, 'index'>) => {
    setVideoList((prevState) => {
      const id = file.id;
      if (uploadCancelCache.current.includes(id)) {
        return prevState;
      }
      const idx = prevState.findIndex((item) => item.id === id);
      if (idx === -1) {
        return normalizeVideoList([...prevState, { ...file, index: prevState.length }]);
      }
      const nextState = [...prevState];
      nextState.splice(idx, 1, {
        ...nextState[idx],
        ...file,
      });
      return normalizeVideoList(nextState);
    });
  };
  const updateVideoById = (id: string, updater: (video: TVideNode) => TVideNode) => {
    setVideoList((prevState) => {
      const idx = prevState.findIndex((item) => item.id === id);
      if (idx === -1) {
        return prevState;
      }
      const nextState = [...prevState];
      nextState.splice(idx, 1, updater(nextState[idx]));
      return normalizeVideoList(nextState);
    });
  };
  const removeVideoById = (id: string) => {
    setVideoList((prevState) => normalizeVideoList(prevState.filter((item) => item.id !== id)));
  };
  const items: MenuProps['items'] = [
    {
      key: '1',
      label: '选择学院视频',
      icon: <ImportOutlined rotate={90} />,
    },
    {
      key: '2',
      label: (
        <VideoUpload
          ref={videoUploadRef}
          onChange={(file) => {
            upsertVideo(file);
          }}
        >
          手动上传视频
        </VideoUpload>
      ),
      icon: <UploadOutlined />,
    },
  ];
  useUpdateEffect(() => {
    console.log('videoList变化', videoList);
    onChange(videoList);
    uploadCache.current = videoList;
    console.log('uploadCache 111是', uploadCache.current);
  }, [videoList]);

  useEffect(() => {
    //if (
    //  Array.isArray(defaultValue) &&
    //  !isEqualWith(defaultValue, videoList, isEqual) &&
    //  !isSetDefaultValue.current
    //) {
    //  console.log('defaultValue变化', defaultValue, videoList);
    //  setVideoList(defaultValue);
    //  isSetDefaultValue.current = true;
    //}
  }, [defaultValue, videoList]);
  useEffect(() => {
    toggleIsFullScreen?.(visible);
  }, [visible]);
  return (
    <div className={styles.video_com}>
      <DragList<TVideNode>
        data={videoList}
        tableProps={{
          columns: [
            {
              title: ' ',
              key: 'sort',
              dataIndex: 'sort',
              width: 30,
              render: () => <MenuOutlined style={{ cursor: 'grab', color: '#999' }} />,
            },
            {
              dataIndex: 'name',
              key: 'name',
              title: '视频',
              render: (value, record) => {
                if (record.source === EVideoSource.fr_academy) {
                  return (
                    <a href={`${process.env.EDU_URL}/video/play/${record.id}`} target="_blank">
                      {value}
                    </a>
                  );
                }
                const defaultCom = (
                  <VideoDuration
                    url={record.url!}
                    onChange={(duration) => {
                      updateVideoById(record.id, (video) => ({ ...video, duration }));
                    }}
                  >
                    <NameEdit
                      maxCount={50}
                      showEditIcon
                      defaultValue={value}
                      onNameChange={(name) => {
                        updateVideoById(record.id, (video) => ({ ...video, name }));
                        return true;
                      }}
                    />
                  </VideoDuration>
                );
                if (!isUndefined(record.uploadStatus)) {
                  switch (record.uploadStatus) {
                    case EVideoUploadStatus.loading:
                      return (
                        <Space>
                          {value}
                          <Space>
                            <Spin />
                            {record.uploadPercentage && (
                              <span className="text-c0c0c0">{record.uploadPercentage}%</span>
                            )}
                            <span
                              className="text-blue cursor-pointer"
                              onClick={() => {
                                uploadCancelCache.current = [
                                  ...uploadCancelCache.current,
                                  record.id,
                                ];
                                removeVideoById(record.id);
                                const cacheIdx = uploadCache.current.findIndex(
                                  (item) => item.id === record.id,
                                );
                                if (cacheIdx > -1) {
                                  uploadCache.current.splice(cacheIdx, 1);
                                }
                              }}
                            >
                              取消
                            </span>
                          </Space>
                        </Space>
                      );
                    case EVideoUploadStatus.fail:
                      return (
                        <Space>
                          {value}
                          <Space>
                            <Space className="text-red">
                              <CloseCircleOutlined />
                              上传失败
                            </Space>
                            <span
                              className="text-blue cursor-pointer"
                              onClick={() => {
                                videoUploadRef?.current?.retry(record);
                              }}
                            >
                              重试
                            </span>
                          </Space>
                        </Space>
                      );
                    case EVideoUploadStatus.success:
                      return defaultCom;
                  }
                }
                return defaultCom;
              },
            },
            {
              dataIndex: 'source',
              key: 'source',
              title: '视频来源',
              render: (value) => {
                if (value === EVideoSource.fr_academy) {
                  return '帆软学院';
                } else if (value === EVideoSource.self_upload) {
                  return '手动上传';
                } else {
                  return '--';
                }
              },
            },
            {
              dataIndex: 'duration',
              key: 'duration',
              title: '时长',
              render: (value, record) => {
                // if (record.uploadStatus === EVideoUploadStatus.loading) {
                //   return '视频时长获取中...';
                // }
                if (value === -1 || (value === 0 && record.source === EVideoSource.self_upload)) {
                  return (
                    <Space>
                      <span>无法获取时长</span>
                      <SetDuration
                        onSubmit={(duration) => {
                          updateVideoById(record.id, (video) => ({ ...video, duration }));
                        }}
                      />
                    </Space>
                  );
                }
                return formatVideoDuration(value);
              },
            },
            {
              dataIndex: 'operation',
              key: 'operation',
              title: '操作',
              render: (_, record) => {
                return (
                  <Popconfirm
                    title="确认删除该视频吗？此修改节点保存后才生效"
                    onConfirm={() => {
                      removeVideoById(record.id);
                    }}
                    okText="删除"
                    okType="danger"
                    cancelText="取消"
                  >
                    <DeleteOutlined className="text-808696 cursor-pointer" />
                  </Popconfirm>
                );
              },
            },
          ],
        }}
        onDragEnd={(data) => {
          setVideoList(
            normalizeVideoList(
              data.reduce<TVideNode[]>((temp, item) => {
                const findItem = videoList.find((videoItem) => videoItem.id === item.id);
                if (findItem) {
                  temp.push(findItem);
                }
                return temp;
              }, []),
            ),
          );
        }}
      />
      <div className={styles.video_com_footer}>
        <Dropdown
          menu={{
            items,
            onClick: (e) => {
              console.log(e);
              if (e.key === '1') {
                setVisible(true);
              }
            },
          }}
        >
          <Button type="link" icon={<PlusSquareOutlined />} onClick={() => {}}>
            添加视频
          </Button>
        </Dropdown>
      </div>
      <VideoModal
        visible={visible}
        onOk={(selectVideos) => {
          setVideoList((prevState) => {
            const filterSelectedVideos = selectVideos.filter(
              (item) => !prevState.find((videoListItem) => videoListItem.id === item.id),
            );
            return normalizeVideoList(
              prevState.concat(
                filterSelectedVideos.map((item, index) => ({
                  id: item.id,
                  name: item.name,
                  url: item.url,
                  source: EVideoSource.fr_academy,
                  duration: item.duration,
                  size: item.size,
                  resolution: item.resolution,
                  index: prevState.length + index,
                })),
              ),
            );
          });
          setVisible(false);
        }}
        onClose={() => {
          setVisible(false);
        }}
      />
    </div>
  );
};
export default VideoCom;

function isEauqlWith(defaultValue: TVideNode[], videoList: TVideNode[]) {
  throw new Error('Function not implemented.');
}
